// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"126":"700a5944","224":"5565ef95","747":"2e4dbee2"}[chunkId] + ".chunk.js";
};